<template>
  <ChipList
    :item="{items: advanced_filter_items}"
    :disable="disable"
    @update="chip_clicked"
  ></ChipList>
</template>
  
<script>
  import { mapGetters } from 'vuex';
  import QUnit from '@/api/QUnit';
  import ChipGeneric from '@/components/explorer/chips/ChipGeneric';
  import ChipUser from '@/components/explorer/chips/ChipUser';
  import ChipDateRange from '@/components/explorer/chips/ChipDateRange';
  import ChipDateField from '@/components/explorer/chips/ChipDateField';
  import ChipProcess from '@/components/explorer/chips/ChipProcess';
  import ChipProcesses from '@/components/explorer/chips/ChipProcesses';

  
  export default {
    name: 'AdvancedFilterChip',
  
    props: {
      item: {type: Object},
      disable: {
        type: Boolean,
        default: false,
      },
    },
  
    components: {
      ChipList: () => import('@/components/explorer/chips/ChipList'),
      ChipGeneric,
      ChipUser,
      ChipDateRange,
      ChipDateField,
      ChipProcess,
      ChipProcesses,
    },
  
    data: () => ({
      raw_fields: [],
    }),
  
    computed: {
      ...mapGetters(['centro_id']),
      business_process() {
        return this.$route.query.business_process;
      },
      advanced_filter_items() {
        return this.raw_fields.map(item => ({component: this.getComponent(item),
                                              readable: item.label,
                                              name: item.id,
                                              value: this.item.value[item.id],
                                              readableValue: this.getReadableValue(item)}));
      },
    },
  
    mounted(){
      this.query_fields();
    },
  
    methods: {
      getComponent(item) {
        return 'ChipGeneric';

        /*if(item.multiple) {
          return 'ChipList';
        } else {
          return 'ChipGeneric';
        }*/
      },
      async query_fields() {
        if (! this.business_process) {
          this.raw_fields = [];
        } else {
          const data = await QUnit.getFieldsToCollectForFiltering(this.centro_id, this.business_process);
          this.raw_fields = data.fields;
        }
      },
      getReadableValue(item) {
        let found = null;
        if(item.items) {
          if (item.multiple) {
            found = [];
            const items = (this.item.value[item.id] || "").split(',')
            for (let value of items) {
              let exist = Object.fromEntries(item.items)[value]
              if (exist) {
                found.push(exist);
              }
            }
            found = found.join(', ')
          } else {
            found = Object.fromEntries(item.items)[this.item.value[item.id]]
          }
          return found;
        } else {
          return this.item.value[item.id];
        }
      },
      chip_clicked(chip_name) {
        let filter_chip_name = chip_name;
        filter_chip_name.parent='advanced_filters';
        this.$emit('update',filter_chip_name);
      },
    },
  }  
</script>
  
